module.exports = __webpack_public_path__ + "img/Netzelektriker.9db28af3.jpg";